var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatienticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 35.2281,
    rx: 17,
    fill: "#00BD7F",
    fillOpacity: 0.16,
    stroke: "#00BD7F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8073 17.4387C19.842 17.4387 21.4915 15.7893 21.4915 13.7545C21.4915 11.7198 19.842 10.0703 17.8073 10.0703C15.7725 10.0703 14.123 11.7198 14.123 13.7545C14.123 15.7893 15.7725 17.4387 17.8073 17.4387Z",
    fill: "#00BD7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5882 18.1758H17.0261C16.1098 18.1787 15.203 18.362 14.3575 18.7154C13.512 19.0687 12.7444 19.5852 12.0985 20.2352C11.4526 20.8852 10.941 21.6561 10.593 22.5038C10.2451 23.3515 10.0674 24.2594 10.0703 25.1758C10.0703 25.2735 10.1092 25.3672 10.1783 25.4363C10.2473 25.5054 10.3411 25.5442 10.4388 25.5442H25.1756C25.2779 25.5349 25.3728 25.4871 25.4412 25.4105C25.5096 25.3339 25.5463 25.2342 25.544 25.1316C25.5401 23.288 24.806 21.521 23.5024 20.2174C22.1988 18.9138 20.4318 18.1797 18.5882 18.1758Z",
    fill: "#00BD7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatienticon);
export default __webpack_public_path__ + "static/media/patienticon.d536b8b3c192c14848853e5662964d49.svg";
export { ForwardRef as ReactComponent };